import ApiService from "../api.services";

const ExternalService = {
  list: async function () {
    try {
      const response = await ApiService.get("/api/external");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/external/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getByOrderId: async function (order_id) {
    try {
      const response = await ApiService.get(
        `/api/external/search/byorderid/${order_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  plp: async function (plp, tag) {
    try {
      const response = await ApiService.get(`/api/external/${plp}/${tag}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (data) {
    try {
      const res = await ApiService.post("/api/external", data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  print: async function (id) {
    try {
      const res = await ApiService.get(`/api/external/print/tag/${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  tags: async function (
    id,
    customer,
    startedAt,
    finishedAt,
    service,
    filter,
    records,
    page
  ) {
    try {
      const data = {
        customer,
        startedAt,
        finishedAt,
        service,
        filter,
      };
      const res = await ApiService.post(
        `/api/external/list/tags/${id}?records=${records}&page=${page}`,
        data
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  resume: async function (customer, startedAt, finishedAt, service, filter) {
    try {
      const data = {
        customer,
        startedAt,
        finishedAt,
        service,
        filter,
      };
      const res = await ApiService.post("/api/external/resume", data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  export: async function (customer, startedAt, finishedAt, service, filter) {
    try {
      const data = {
        customer,
        startedAt,
        finishedAt,
        service,
        filter,
      };
      const res = await ApiService.post("/api/external/export", data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (id, data) {
    try {
      const res = await ApiService.put(`/api/external/${id}`, data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const res = await ApiService.delete(`/api/external/${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  register: async function (data, tags) {
    data.tags = tags;
    try {
      const res = await ApiService.post(`/api/external/register`, data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ExternalService;

export { ExternalService };
